import { Home, Shirt, Camera, LayoutGrid, User } from "lucide-react"
import { Link, useLocation } from "react-router-dom"

interface NavItem {
  icon: React.ComponentType<{ className?: string }>
  label: string
  href: string
}

const navItems: NavItem[] = [
  { icon: Home, label: "Home", href: "/" },
  { icon: Shirt, label: "Wardrobe", href: "/wardrobe" },
  { icon: Camera, label: "Camera", href: "/camera" },
  { icon: LayoutGrid, label: "Fits", href: "/fits" },
  { icon: User, label: "Profile", href: "/profile" },
]

export function BottomNav() {
  const pathname = useLocation().pathname

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border safe-area-inset-bottom z-30">
      <div className="flex items-center justify-around py-2 px-4 max-w-lg mx-auto">
        {navItems.map((item) => {
          const isActive = pathname === item.href || (item.href !== "/" && pathname.startsWith(item.href))
          return (
            <Link
              key={item.label}
              to={item.href}
              className={`flex flex-col items-center gap-1 py-2 px-4 rounded-xl transition-all ${
                isActive
                  ? "text-primary"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              <item.icon className={`w-6 h-6 ${isActive ? "stroke-[2.5]" : ""}`} />
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
